import React from "react";
import {safeHTML} from "../../utils/safeHTML";
import Button from "../baseComponents/gui/button/Button";
import buttonStyles from "../baseComponents/gui/button/Button.module.scss";
import Icon from "../baseComponents/gui/icon/Icon";
import Link from "next/link";
import styles from "./Podcasts.module.scss";
import classNames from "classnames";


const PodcastsItem = React.forwardRef(
  function PodcastsItem(props, ref) {

    const {title, text, image, list, href, button, extraLink} = props;
    const icons = list?.map((item, index) => {
      const url = new URL(item.url);
      const domain = url.hostname;
      return (<a href={item.url}
         target={"_blank"}
         className={styles.podcasts__itemIcon}
         key={`icon-${index}`}
         area-label={`подкаст на ${domain}`}
         title={`подкаст на ${domain}`}
      >
        <img src={item?.mono_image} alt="монохромная картинка" loading="lazy" width={56} height={56}/>
      </a>)
    });


    return (
        <div className={styles.podcasts__item}  ref={ref}>


          <div className={styles.podcasts__itemImage}>
            <img src={image} alt={title} loading="lazy" fetchpriority={"auto"} width={480} height={272}/>
          </div>
          <div className={styles.podcasts__itemTitle}>{safeHTML(title)}</div>
          <div className={styles.podcasts__itemText}>{safeHTML(text)}</div>

          <Button tag={'a'}
                  target={'_blank'}
                  className={classNames(
                    buttonStyles.button_big,
                    buttonStyles.button_white,
                    styles.podcasts__itemButton
                  )}>
            <div className={buttonStyles.button__text}>{safeHTML(button.textBtn)}</div>
            <div className={buttonStyles.button__icon}>
              {extraLink
                ? <Icon name={'link'}/>
                : <Icon name={"arrow-btn"} width={16} height={16}/>
              }
            </div>
          </Button>

          <Link legacyBehavior  href={extraLink || href}  >
            <a className={styles.podcasts__itemLinkMask} target={extraLink && '_blank'}>
            </a>
          </Link>



          <div className={styles.podcasts__itemIcons}>
            {icons}
          </div>
        </div>
    );
  });
export default PodcastsItem;
PodcastsItem.propTypes = {};

